import * as XLSX from "xlsx";

export const downloadBlumTemplate = () => {
  const wsData = [
    // Required header row
    [
      "Vendor", "Category", "Sub Category", "Article ID", 
      "Description", "Information", "Internal Type", "Shutter Type", 
      "Width", "Height", "Depth", "UOM", "MOQ", "Quantity", 
      "Blum Price", "Verve Price", "Image", "Remarks"
    ],
    
    // Example row
    [
      "Vendor A", "", "", "",
      "Sample Description", "", "", "",
      "", "", "", "nos", 1, 2, 
      5000, 6000, "", "Sample remark"
    ]
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Styling column widths for a premium look when opened
  const wscols = [
    { wch: 20 }, // Vendor
    { wch: 15 }, // Category
    { wch: 15 }, // Sub Category
    { wch: 15 }, // Article ID
    { wch: 30 }, // Description
    { wch: 25 }, // Information
    { wch: 15 }, // Internal Type
    { wch: 15 }, // Shutter Type
    { wch: 10 }, // Width
    { wch: 10 }, // Height
    { wch: 10 }, // Depth
    { wch: 10 }, // UOM
    { wch: 10 }, // MOQ
    { wch: 10 }, // Quantity
    { wch: 15 }, // Blum Price
    { wch: 15 }, // Verve Price
    { wch: 20 }, // Image
    { wch: 20 }, // Remarks
  ];
  ws['!cols'] = wscols;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Purchase Master");

  // Trigger download natively
  XLSX.writeFile(wb, "PurchaseMasterTemplete.xlsx");
};
